import React from "react";
export default function Modal(props) {
  const dialogClasses = ["modal-dialog"];
  if (props.xl) {
    dialogClasses.push("modal-xl");
  }
  if (props.center) {
    dialogClasses.push("modal-dialog-centered");
  }

  const onBodyClick = (e) => {
    e.stopPropagation();
  };
  const onBackdropClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.onClose();
  };

  return (
    <>
      {props.show && <div className="modal-backdrop show"></div>}
      <div
        style={{ display: props.show ? "block" : "none", overflowY: "auto" }}
        className="modal mounted-modal"
        onMouseDown={onBackdropClick}
      >
        <div onMouseDown={onBodyClick} className={dialogClasses.join(" ")}>
          <div className="modal-content">
            <div className="modal-body">{props.children}</div>
          </div>
        </div>
      </div>
    </>
  );
}
